import type { Dayjs } from "dayjs";

import { COLORS, FONT_FAMILY } from "./styles";

function formatAbsolute(d: Dayjs): string {
  const tz = Intl.DateTimeFormat("en-US", {
    timeZoneName: "short",
  })
    .formatToParts(new Date())
    .find((p) => p.type === "timeZoneName")?.value;
  const base = d.format("MMM D, YYYY • h:mm A");
  return tz ? `${base} ${tz}` : base;
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: 12,
          fontWeight: 500,
          color: COLORS.textTertiary,
          letterSpacing: 0.4,
        }}
      >
        {label}
      </span>
      <span
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: 13,
          fontWeight: 500,
          color: COLORS.textPrimary,
        }}
      >
        {value}
      </span>
    </div>
  );
}

type Props = {
  start: Dayjs | undefined;
  end: Dayjs | undefined;
};

export default function InternalDetails({ start, end }: Props) {
  if (!start && !end) return null;
  return (
    <>
      <div style={{ width: "100%", height: 1, background: COLORS.border }} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          width: "100%",
          padding: "4px 16px",
        }}
      >
        {start && <Row label="Started" value={formatAbsolute(start)} />}
        {end && <Row label="Ends" value={formatAbsolute(end)} />}
      </div>
    </>
  );
}

export function InternalBadge() {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 10px",
        background: COLORS.dark,
        borderRadius: 999,
      }}
    >
      <span
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: 10,
          fontWeight: 700,
          color: COLORS.light,
          letterSpacing: 0.8,
        }}
      >
        INTERNAL ORG
      </span>
    </div>
  );
}
